import { render, staticRenderFns } from "./PurchasedHistory.vue?vue&type=template&id=2b1c7402&scoped=true"
import script from "./PurchasedHistory.vue?vue&type=script&lang=js"
export * from "./PurchasedHistory.vue?vue&type=script&lang=js"
import style0 from "./PurchasedHistory.vue?vue&type=style&index=0&id=2b1c7402&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1c7402",
  null
  
)

export default component.exports